import { Tooltip as BaseTooltip } from "@base-ui/react/tooltip";
import type { ComponentProps, ReactNode } from "react";
import { cn } from "../utils";

export function TooltipProvider({
  delay = 400,
  ...props
}: ComponentProps<typeof BaseTooltip.Provider>) {
  return <BaseTooltip.Provider delay={delay} {...props} />;
}

export function Tooltip({
  content,
  children,
  className,
  ...props
}: ComponentProps<typeof BaseTooltip.Root> & {
  content: ReactNode;
  children: ReactNode;
  className?: string;
}) {
  return (
    <BaseTooltip.Root {...props}>
      <BaseTooltip.Trigger render={<span>{children}</span>} />
      <BaseTooltip.Portal>
        <BaseTooltip.Positioner sideOffset={6} className="z-50">
          <BaseTooltip.Popup
            className={cn(
              "rounded-control bg-ink px-2 py-1 text-2xs text-ink-inverse shadow-overlay",
              "origin-[var(--transform-origin)] transition-[transform,opacity] duration-[125ms] ease-swift",
              "data-[starting-style]:scale-[0.97] data-[starting-style]:opacity-0",
              "data-[ending-style]:scale-[0.97] data-[ending-style]:opacity-0",
              "data-instant:duration-0",
              className,
            )}
          >
            {content}
          </BaseTooltip.Popup>
        </BaseTooltip.Positioner>
      </BaseTooltip.Portal>
    </BaseTooltip.Root>
  );
}
